import { useMemo, useState } from "react";

const MESSAGE_TABS = {
  MESSAGES: "Messages",
  NOTES: "Notes",
};

function useConversationMessagesTabs() {
  const [activeTab, setActiveTab] = useState(MESSAGE_TABS.MESSAGES);

  const tabs = useMemo(() => {
    return Object.values(MESSAGE_TABS).map((tab) => {
      return {
        name: tab,
        current: tab === activeTab,
      };
    });
  }, [activeTab]);

  return {
    activeTab,
    tabs,
    setActiveTab,
  };
}

const WHATSAPP_TABS = {
  MESSAGES: "Messages",
  NOTES: "Notes",
  CALLS: "Calls",
};

function useWhatsappConversationTabs() {
  const [activeTab, setActiveTab] = useState(WHATSAPP_TABS.MESSAGES);

  const tabs = useMemo(() => {
    return Object.values(WHATSAPP_TABS).map((tab) => {
      return {
        name: tab,
        current: tab === activeTab,
      };
    });
  }, [activeTab]);

  return {
    activeTab,
    tabs,
    setActiveTab,
  };
}

export {
  useConversationMessagesTabs,
  MESSAGE_TABS,
  WHATSAPP_TABS,
  useWhatsappConversationTabs,
};
